/**
 * Mock Certificate Data
 *
 * Comprehensive mock certificate database for development and testing.
 */

import type { Certificate, CertificateStatus, CertificateType, CertificateStatistics } from '../../types/certificate';

export const mockCertificates: Certificate[] = [
  {
    id: '1',
    certificateNumber: 'CERT-20250101-001',
    companyId: '1',
    companyName: 'Kantin Warisan Sdn Bhd',
    applicationId: 'APP-001',
    type: 'RESTAURANT',
    status: 'ACTIVE',
    issueDate: '2025-01-01',
    expiryDate: '2027-01-01',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustaz Mohamed Ibrahim',
    productCategory: 'Malaysian Cuisine',
    scope: 'Food Preparation and Service - Malaysian Cuisine',
    address: 'No. 123, Jalan Maarof, Bangsar, 59100 Kuala Lumpur',
    verificationCode: 'VER-2025-001-KW-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20250101-001.png',
    certificateUrl: '/certificates/pdf/CERT-20250101-001.pdf',
    remarks: 'Initial certification',
    createdAt: '2025-01-01T10:00:00Z',
    updatedAt: '2025-01-01T10:00:00Z',
  },
  {
    id: '2',
    certificateNumber: 'CERT-20241230-005',
    companyId: '5',
    companyName: 'Restoran Al-Barakah',
    applicationId: 'APP-005',
    type: 'FOOD_PREMISE',
    status: 'ACTIVE',
    issueDate: '2024-12-30',
    expiryDate: '2026-12-30',
    issuedBy: 'JAIS',
    issuedByOfficer: 'Ustazah Aminah',
    productCategory: 'Middle Eastern Cuisine',
    scope: 'Restaurant Operations - Middle Eastern and Halal Food',
    address: 'Lot 45, Jalan Sultan, Petaling Jaya, 46000 Selangor',
    verificationCode: 'VER-2024-305-AB-JAIS',
    qrCodeUrl: '/certificates/qr/CERT-20241230-005.png',
    certificateUrl: '/certificates/pdf/CERT-20241230-005.pdf',
    createdAt: '2024-12-30T14:30:00Z',
    updatedAt: '2024-12-30T14:30:00Z',
  },
  {
    id: '3',
    certificateNumber: 'CERT-20241229-003',
    companyId: '7',
    companyName: 'Bakery House Sdn Bhd',
    applicationId: 'APP-007',
    type: 'FOOD_PRODUCT',
    status: 'ACTIVE',
    issueDate: '2024-12-29',
    expiryDate: '2026-12-29',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustaz Yusof',
    productCategory: 'Bakery Products',
    scope: 'Production of Halal Bread, Cakes, and Pastries',
    address: 'No. 789, Jalan Industri, Shah Alam, 40000 Selangor',
    verificationCode: 'VER-2024-293-BH-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20241229-003.png',
    certificateUrl: '/certificates/pdf/CERT-20241229-003.pdf',
    createdAt: '2024-12-29T11:15:00Z',
    updatedAt: '2024-12-29T11:15:00Z',
  },
  {
    id: '4',
    certificateNumber: 'CERT-20241228-002',
    companyId: '9',
    companyName: 'Food Processing Co',
    applicationId: 'APP-009',
    type: 'FOOD_PREPARATION',
    status: 'ACTIVE',
    issueDate: '2024-12-28',
    expiryDate: '2026-12-28',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustazah Khadijah',
    productCategory: 'Processed Foods',
    scope: 'Food Processing and Packaging - Ready-to-Eat Meals',
    address: 'Plot 12, Kawasan Perindustrian, Nilai, 71800 Negeri Sembilan',
    verificationCode: 'VER-2024-282-FP-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20241228-002.png',
    certificateUrl: '/certificates/pdf/CERT-20241228-002.pdf',
    createdAt: '2024-12-28T09:45:00Z',
    updatedAt: '2024-12-28T09:45:00Z',
  },
  {
    id: '5',
    certificateNumber: 'CERT-20241227-001',
    companyId: '13',
    companyName: 'Catering Services Ltd',
    applicationId: 'APP-013',
    type: 'FOOD_PREMISE',
    status: 'ACTIVE',
    issueDate: '2024-12-27',
    expiryDate: '2026-12-27',
    issuedBy: 'JAIS',
    issuedByOfficer: 'Ustaz Hafiz',
    productCategory: 'Catering Services',
    scope: 'Event Catering and Food Service',
    address: 'Unit 5-2, Plaza Sentral, Jalan Stesen Sentral, 50470 Kuala Lumpur',
    verificationCode: 'VER-2024-271-CS-JAIS',
    qrCodeUrl: '/certificates/qr/CERT-20241227-001.png',
    certificateUrl: '/certificates/pdf/CERT-20241227-001.pdf',
    createdAt: '2024-12-27T16:20:00Z',
    updatedAt: '2024-12-27T16:20:00Z',
  },
  {
    id: '6',
    certificateNumber: 'CERT-20241115-008',
    companyId: '15',
    companyName: 'Halal Food Industries',
    applicationId: 'APP-015',
    type: 'FOOD_PRODUCT',
    status: 'ACTIVE',
    issueDate: '2024-11-15',
    expiryDate: '2026-11-15',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustaz Mohamed Ibrahim',
    productCategory: 'Packaged Foods',
    scope: 'Manufacturing of Halal Snacks and Packaged Foods',
    address: 'Lot 234, Jalan Perusahaan, Klang, 41200 Selangor',
    verificationCode: 'VER-2024-115-HFI-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20241115-008.png',
    certificateUrl: '/certificates/pdf/CERT-20241115-008.pdf',
    createdAt: '2024-11-15T10:00:00Z',
    updatedAt: '2024-11-15T10:00:00Z',
  },
  {
    id: '7',
    certificateNumber: 'CERT-20241020-006',
    companyId: '17',
    companyName: 'Restoran Warisan',
    applicationId: 'APP-017',
    type: 'RESTAURANT',
    status: 'ACTIVE',
    issueDate: '2024-10-20',
    expiryDate: '2026-10-20',
    issuedBy: 'JAIS',
    issuedByOfficer: 'Ustazah Aminah',
    productCategory: 'Traditional Malay Cuisine',
    scope: 'Restaurant Operations - Traditional Malay Food',
    address: 'No. 56, Jalan Raja Chulan, 50200 Kuala Lumpur',
    verificationCode: 'VER-2024-020-RW-JAIS',
    qrCodeUrl: '/certificates/qr/CERT-20241020-006.png',
    certificateUrl: '/certificates/pdf/CERT-20241020-006.pdf',
    createdAt: '2024-10-20T13:30:00Z',
    updatedAt: '2024-10-20T13:30:00Z',
  },
  {
    id: '8',
    certificateNumber: 'CERT-20240915-004',
    companyId: '19',
    companyName: 'Meat Processing Plant',
    applicationId: 'APP-019',
    type: 'SLAUGHTERHOUSE',
    status: 'ACTIVE',
    issueDate: '2024-09-15',
    expiryDate: '2026-09-15',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustaz Yusof',
    productCategory: 'Meat Processing',
    scope: 'Slaughtering and Meat Processing Operations',
    address: 'Lot 1001, Kawasan Perindustrian Batu Caves, 68100 Selangor',
    verificationCode: 'VER-2024-915-MPP-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20240915-004.png',
    certificateUrl: '/certificates/pdf/CERT-20240915-004.png',
    createdAt: '2024-09-15T08:00:00Z',
    updatedAt: '2024-09-15T08:00:00Z',
  },
  {
    id: '9',
    certificateNumber: 'CERT-20240801-007',
    companyId: '11',
    companyName: 'Nasi Lemak Express Sdn Bhd',
    applicationId: 'APP-011',
    type: 'RESTAURANT',
    status: 'ACTIVE',
    issueDate: '2024-08-01',
    expiryDate: '2026-08-01',
    issuedBy: 'JAIS',
    issuedByOfficer: 'Ustaz Hafiz',
    productCategory: 'Fast Food',
    scope: 'Quick Service Restaurant - Malaysian Fast Food',
    address: 'No. 88, Jalan Ampang, 50450 Kuala Lumpur',
    verificationCode: 'VER-2024-801-NLE-JAIS',
    qrCodeUrl: '/certificates/qr/CERT-20240801-007.png',
    certificateUrl: '/certificates/pdf/CERT-20240801-007.pdf',
    createdAt: '2024-08-01T14:00:00Z',
    updatedAt: '2024-08-01T14:00:00Z',
  },
  {
    id: '10',
    certificateNumber: 'CERT-20230315-002',
    companyId: '21',
    companyName: 'Seafood Delights Co',
    applicationId: 'APP-021',
    type: 'FOOD_PRODUCT',
    status: 'EXPIRED',
    issueDate: '2023-03-15',
    expiryDate: '2025-03-15',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustaz Mohamed Ibrahim',
    productCategory: 'Seafood Products',
    scope: 'Processing and Packaging of Halal Seafood',
    address: 'Lot 567, Pelabuhan Klang, 42000 Selangor',
    verificationCode: 'VER-2023-315-SD-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20230315-002.png',
    certificateUrl: '/certificates/pdf/CERT-20230315-002.pdf',
    remarks: 'Expired - renewal pending',
    createdAt: '2023-03-15T10:30:00Z',
    updatedAt: '2025-03-16T00:00:00Z',
  },
  {
    id: '11',
    certificateNumber: 'CERT-20240520-010',
    companyId: '1',
    companyName: 'Kantin Warisan Sdn Bhd',
    applicationId: 'APP-002',
    type: 'RESTAURANT',
    status: 'REVOKED',
    issueDate: '2024-05-20',
    expiryDate: '2026-05-20',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustazah Khadijah',
    productCategory: 'Malaysian Cuisine',
    scope: 'Food Preparation and Service - Malaysian Cuisine',
    address: 'No. 123, Jalan Maarof, Bangsar, 59100 Kuala Lumpur',
    verificationCode: 'VER-2024-520-KW-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20240520-010.png',
    certificateUrl: '/certificates/pdf/CERT-20240520-010.pdf',
    remarks: 'Revoked due to non-compliance during audit',
    createdAt: '2024-05-20T09:00:00Z',
    updatedAt: '2024-12-01T15:30:00Z',
    revokedAt: '2024-12-01T15:30:00Z',
    revokedBy: 'Admin User',
    revokedReason: 'Non-compliance with halal standards during surprise audit',
  },
  {
    id: '12',
    certificateNumber: 'CERT-20250415-009',
    companyId: '9',
    companyName: 'Food Processing Co',
    applicationId: 'APP-010',
    type: 'LOGISTICS',
    status: 'ACTIVE',
    issueDate: '2024-04-15',
    expiryDate: '2026-04-15',
    issuedBy: 'JAKIM',
    issuedByOfficer: 'Ustaz Yusof',
    productCategory: 'Logistics and Transportation',
    scope: 'Halal Food Logistics and Cold Chain Management',
    address: 'Lot 999, Jalan Logistik, Port Klang, 42000 Selangor',
    verificationCode: 'VER-2024-415-FPC-JAKIM',
    qrCodeUrl: '/certificates/qr/CERT-20250415-009.png',
    certificateUrl: '/certificates/pdf/CERT-20250415-009.pdf',
    createdAt: '2024-04-15T11:00:00Z',
    updatedAt: '2024-04-15T11:00:00Z',
  },
];

/**
 * Get certificate by ID
 */
export function getCertificateById(id: string): Certificate | undefined {
  return mockCertificates.find((cert) => cert.id === id);
}

/**
 * Get certificate by certificate number
 */
export function getCertificateByCertificateNumber(certificateNumber: string): Certificate | undefined {
  return mockCertificates.find(
    (cert) => cert.certificateNumber.toLowerCase() === certificateNumber.toLowerCase()
  );
}

/**
 * Get certificate by verification code
 */
export function getCertificateByVerificationCode(verificationCode: string): Certificate | undefined {
  return mockCertificates.find(
    (cert) => cert.verificationCode.toLowerCase() === verificationCode.toLowerCase()
  );
}

/**
 * Get certificates by company ID
 */
export function getCertificatesByCompany(companyId: string): Certificate[] {
  return mockCertificates.filter((cert) => cert.companyId === companyId);
}

/**
 * Get certificates by status
 */
export function getCertificatesByStatus(status: CertificateStatus): Certificate[] {
  return mockCertificates.filter((cert) => cert.status === status);
}

/**
 * Get certificates by type
 */
export function getCertificatesByType(type: CertificateType): Certificate[] {
  return mockCertificates.filter((cert) => cert.type === type);
}

/**
 * Get expiring certificates (within 90 days)
 */
export function getExpiringCertificates(daysThreshold: number = 90): Certificate[] {
  const today = new Date();
  const thresholdDate = new Date();
  thresholdDate.setDate(today.getDate() + daysThreshold);

  return mockCertificates.filter((cert) => {
    if (cert.status !== 'ACTIVE') return false;
    const expiryDate = new Date(cert.expiryDate);
    return expiryDate >= today && expiryDate <= thresholdDate;
  });
}

/**
 * Search certificates
 */
export function searchCertificates(query: string): Certificate[] {
  const lowerQuery = query.toLowerCase();
  return mockCertificates.filter(
    (cert) =>
      cert.certificateNumber.toLowerCase().includes(lowerQuery) ||
      cert.companyName.toLowerCase().includes(lowerQuery) ||
      cert.verificationCode.toLowerCase().includes(lowerQuery) ||
      (cert.productCategory && cert.productCategory.toLowerCase().includes(lowerQuery))
  );
}

/**
 * Get all certificates
 */
export function getAllCertificates(): Certificate[] {
  return mockCertificates;
}

/**
 * Get certificate statistics
 */
export function getCertificateStatistics(): CertificateStatistics {
  const stats: CertificateStatistics = {
    total: mockCertificates.length,
    active: mockCertificates.filter((c) => c.status === 'ACTIVE').length,
    expiringSoon: getExpiringCertificates(90).length,
    expired: mockCertificates.filter((c) => c.status === 'EXPIRED').length,
    revoked: mockCertificates.filter((c) => c.status === 'REVOKED').length,
    byType: {
      FOOD_PREMISE: mockCertificates.filter((c) => c.type === 'FOOD_PREMISE').length,
      FOOD_PRODUCT: mockCertificates.filter((c) => c.type === 'FOOD_PRODUCT').length,
      SLAUGHTERHOUSE: mockCertificates.filter((c) => c.type === 'SLAUGHTERHOUSE').length,
      LOGISTICS: mockCertificates.filter((c) => c.type === 'LOGISTICS').length,
      RESTAURANT: mockCertificates.filter((c) => c.type === 'RESTAURANT').length,
      FOOD_PREPARATION: mockCertificates.filter((c) => c.type === 'FOOD_PREPARATION').length,
    },
    byMonth: [
      { month: '2024-08', issued: 1 },
      { month: '2024-09', issued: 1 },
      { month: '2024-10', issued: 1 },
      { month: '2024-11', issued: 1 },
      { month: '2024-12', issued: 5 },
      { month: '2025-01', issued: 1 },
    ],
  };

  return stats;
}

/**
 * Verify certificate
 */
export function verifyCertificate(
  certificateNumberOrCode: string
): { isValid: boolean; certificate?: Certificate; message: string } {
  let certificate = getCertificateByCertificateNumber(certificateNumberOrCode);

  if (!certificate) {
    certificate = getCertificateByVerificationCode(certificateNumberOrCode);
  }

  if (!certificate) {
    return {
      isValid: false,
      message: 'Certificate not found',
    };
  }

  if (certificate.status === 'REVOKED') {
    return {
      isValid: false,
      certificate,
      message: 'Certificate has been revoked',
    };
  }

  if (certificate.status === 'EXPIRED') {
    return {
      isValid: false,
      certificate,
      message: 'Certificate has expired',
    };
  }

  const expiryDate = new Date(certificate.expiryDate);
  const today = new Date();

  if (expiryDate < today) {
    return {
      isValid: false,
      certificate,
      message: 'Certificate has expired',
    };
  }

  return {
    isValid: true,
    certificate,
    message: 'Certificate is valid and authentic',
  };
}
